/* Live Free — the quiz (BUILD-10 §2, rebuilt to CODE-QUIZ-REBUILD). No framework, loads only
   on the quiz page. Every screen is in the document; this toggles them, keeps state in the URL
   and routes the product pool the section rendered as JSON. Nothing is fetched to build a result.

   URL:  ?q=3&a=1.4        question 3, answers so far (multi answers joined with +)
         ?r=1.4.2+5.0.1    the result   ?r=…&exit=rx|refer   the result TYPE
         ?share=…&from=X   the parent view (known adult)
   Private questions (prescription, referral) are written to the URL as 0 and never leave memory. */
(function () {
  'use strict';
  var root = document.querySelector('[data-lf-quiz]');
  if (!root) return;
  var data = JSON.parse(root.querySelector('[data-lf-quiz-data]').textContent);
  var pool = (data.pool || []).filter(Boolean);
  var reasons = (data.reasons || []).filter(Boolean);
  var tips = (data.tips || []).filter(Boolean);
  var L = data.labels || {};
  var qs = Array.prototype.slice.call(root.querySelectorAll('[data-lf-q]'));
  var screens = { quiz: root.querySelector('[data-lf-screen="quiz"]'), result: root.querySelector('[data-lf-screen="result"]'), parent: root.querySelector('[data-lf-screen="parent"]') };
  var answers = [];      // per question: 0 = skipped, n = single pick, [n, m] = multi pick
  var exitType = '';     // '', 'rx' or 'refer' — the only trace a private answer leaves
  var result = null;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var LF = ['smooth-sali', 'pore-magic', 'moisturose'];
  var BANDS = ['u12', '13-18', '19-24', '25-39', '40+'];

  /* ---- answers <-> url ---- */
  function isPrivate(i) { return qs[i] && qs[i].hasAttribute('data-private'); }
  function isMulti(i) { return qs[i] && qs[i].hasAttribute('data-multi'); }
  function parseAnswers(str) {
    return String(str || '').split('.').slice(0, qs.length).map(function (x, i) {
      if (x.indexOf('+') !== -1 || isMulti(i)) { var arr = x.split('+').map(function (y) { return parseInt(y, 10) || 0; }).filter(Boolean); return arr.length ? arr : 0; }
      return parseInt(x, 10) || 0;
    });
  }
  function encodeAnswers(upto) {
    var out = [];
    for (var i = 0; i < (upto === undefined ? answers.length : upto); i++) {
      var a = answers[i];
      if (isPrivate(i) || !a) out.push(0);
      else out.push(Array.isArray(a) ? a.join('+') : a);
    }
    return out.join('.');
  }
  function picked(i) { var a = answers[i]; return !a ? [] : (Array.isArray(a) ? a : [a]); }
  function tagsFor() {
    var tags = [], labels = [], keyed = {};
    qs.forEach(function (q, i) {
      if (!visible(i)) return;
      picked(i).forEach(function (n) {
        var btn = q.querySelector('[data-lf-answer="' + n + '"]');
        if (!btn) return;
        if (!isPrivate(i)) labels.push(btn.dataset.label);
        String(btn.dataset.tags || '').split(',').forEach(function (t) {
          t = t.trim(); if (!t) return; tags.push(t);
          var c = t.indexOf(':'); if (c > 0) keyed[t.slice(0, c)] = t.slice(c + 1);
        });
      });
    });
    return { tags: tags, labels: labels, keyed: keyed };
  }
  function has(tags, t) { return tags.indexOf(t) !== -1; }
  /* conditional questions: shown only when one of data-cond's tags was picked earlier */
  function visible(i) {
    var q = qs[i]; if (!q) return false;
    if (!q.dataset.cond) return true;
    var need = q.dataset.cond.split(',').map(function (x) { return x.trim(); });
    for (var j = 0; j < i; j++) {
      var qq = qs[j];
      picked(j).forEach(function (n) { var b = qq.querySelector('[data-lf-answer="' + n + '"]'); if (b) String(b.dataset.tags || '').split(',').forEach(function (t) { if (need.indexOf(t.trim()) !== -1) need.push('__hit'); }); });
    }
    return need.indexOf('__hit') !== -1;
  }
  function visibleIdx() { var v = []; qs.forEach(function (q, i) { if (visible(i)) v.push(i); }); return v; }
  function nextVisible(i) { for (var j = i + 1; j < qs.length; j++) if (visible(j)) return j; return -1; }
  function prevVisible(i) { for (var j = i - 1; j >= 0; j--) if (visible(j)) return j; return -1; }

  function setUrl(params, push) {
    var u = new URL(window.location.href);
    ['q', 'a', 'r', 'exit', 'share', 'from', 'preset'].forEach(function (k) { u.searchParams.delete(k); });
    Object.keys(params).forEach(function (k) { if (params[k] !== undefined && params[k] !== '') u.searchParams.set(k, params[k]); });
    if (push) history.pushState(null, '', u.toString()); else history.replaceState(null, '', u.toString());
  }
  function show(name) {
    Object.keys(screens).forEach(function (k) { if (screens[k]) screens[k].hidden = k !== name; });
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  }

  /* ---- questions ---- */
  function showQuestion(i, push) {
    exitType = '';
    var vis = visibleIdx(); if (!vis.length) return;
    if (vis.indexOf(i) === -1) i = vis[0];
    var pos = vis.indexOf(i) + 1, n = vis.length;
    qs.forEach(function (q, idx) {
      q.hidden = idx !== i;
      var sel = picked(idx);
      q.querySelectorAll('[data-lf-answer]').forEach(function (b) { b.setAttribute('aria-pressed', String(sel.indexOf(parseInt(b.dataset.lfAnswer, 10)) !== -1)); });
      var k = q.querySelector('[data-lf-kicker]'); if (k) k.textContent = k.dataset.lfKicker || ((root.dataset.kickerWord || 'question') + ' ' + (vis.indexOf(idx) + 1) + ' ' + (root.dataset.ofWord || 'of') + ' ' + n);
    });
    var cur = qs[i];
    if (cur && !reduce) { cur.classList.remove('is-in'); void cur.offsetWidth; cur.classList.add('is-in'); }
    var pb = root.querySelector('[data-lf-progress]');
    if (pb) { pb.innerHTML = ''; for (var t = 1; t <= n; t++) { var s = document.createElement('span'); s.className = 'lf-quiz__tick' + (t <= pos ? ' is-done' : ''); pb.appendChild(s); } pb.setAttribute('aria-valuemax', n); pb.setAttribute('aria-valuenow', pos); }
    var c = root.querySelector('[data-lf-count]'); if (c) c.textContent = pos + ' / ' + n;
    var back = root.querySelector('[data-lf-back]'); if (back) back.hidden = pos === 1;
    show('quiz');
    setUrl({ q: i + 1, a: encodeAnswers(i) }, push);
    var h = cur && cur.querySelector('h1'); if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
  }
  function advance(i) {                                                        /* back never loses an answer: later answers stay */
    var nx = nextVisible(i);
    if (nx === -1) showResult(true); else showQuestion(nx, true);
  }
  function answer(i, a) {
    var q = qs[i];
    if (isMulti(i)) {
      var max = parseInt(q.dataset.multi, 10) || 0, cur = picked(i).slice(), at = cur.indexOf(a);
      if (at !== -1) cur.splice(at, 1); else { if (max && cur.length >= max) cur.shift(); cur.push(a); }
      answers[i] = cur.length ? cur : 0;
      q.querySelectorAll('[data-lf-answer]').forEach(function (b) { b.setAttribute('aria-pressed', String(cur.indexOf(parseInt(b.dataset.lfAnswer, 10)) !== -1)); });
      return;
    }
    answers[i] = a;
    advance(i);
  }
  function currentQuestion() { for (var i = 0; i < qs.length; i++) if (!qs[i].hidden) return i; return 0; }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lf-answer]');
    if (b) { answer(parseInt(b.closest('[data-lf-q]').dataset.lfQ, 10) - 1, parseInt(b.dataset.lfAnswer, 10)); return; }
    if (e.target.closest('[data-lf-next]')) { advance(currentQuestion()); return; }
    if (e.target.closest('[data-lf-skip]')) { var i0 = currentQuestion(); answers[i0] = 0; advance(i0); return; }
    if (e.target.closest('[data-lf-back]')) { var pv = prevVisible(currentQuestion()); if (pv !== -1) showQuestion(pv, true); return; }
    if (e.target.closest('[data-lf-change]')) { var vis = visibleIdx(); showQuestion(vis[vis.length - 1], true); return; }
    if (e.target.closest('[data-lf-print]')) { window.print(); return; }
    if (e.target.closest('[data-lf-copy]')) { e.preventDefault(); copyLink(e.target.closest('[data-lf-copy]')); return; }
    if (e.target.closest('[data-lf-see-parent]')) { e.preventDefault(); showParent(senderName(), true); return; }
    if (e.target.closest('[data-lf-add-set]')) { e.preventDefault(); addItem(e.target.closest('[data-lf-add-set]'), root.dataset.setVariant, root.dataset.setAvailable === '1'); return; }
    if (e.target.closest('[data-lf-add-item]')) { e.preventDefault(); var ab = e.target.closest('[data-lf-add-item]'); addItem(ab, ab.dataset.variant, ab.dataset.available === '1'); return; }
  });

  /* ---- routing: the brief's order, on the pool the section rendered ---- */
  function route() {
    var t = tagsFor(), tags = t.tags, k = t.keyed;
    var band = BANDS.indexOf(k.band) !== -1 ? k.band : '13-18';   // unknown age: the primary recommendation
    var r = { tags: tags, labels: t.labels, band: band, audience: k.audience || '', exit: '', core: [], addons: [], always: [], spf: [], fun: null, routine: false, starter: false, parentPrimary: false };
    if (k.refer === 'yes' || exitType === 'refer') { r.exit = 'refer'; return r; }                       // 1. dermatologist. stop.
    var rx = k.rx === 'yes' || exitType === 'rx'; if (rx) r.exit = 'rx';                              // 3. remove smooth sali, recommend less
    var wearer = k.wearer || '';
    var seen = {};
    var elig = pool.filter(function (p) {                                        // 4. candidate pool
      if (!p.av) return false;
      if ((p.bands || []).indexOf(band) === -1) return false;
      var trig = (p.trig || []).some(function (x) { return has(tags, x); });
      if (p.req && !trig) return false;
      if ((p.excl || []).some(function (x) { return has(tags, x); })) return false;   // 5. cross-age removals live in the data
      var w = p.wearer && p.wearer.length ? p.wearer : ['any'];
      if (w.indexOf('any') === -1 && (!wearer || w.indexOf(wearer) === -1)) return false;
      if (rx && p.ph === 'smooth-sali') return false;
      p._trig = trig; return true;
    }).sort(function (a, b) { return (b._trig - a._trig) || (a.pri - b.pri); })
      .filter(function (p) { var key = p.role + ':' + p.ph; if (seen[key]) return false; seen[key] = 1; return true; });
    r.core = elig.filter(function (p) { return p.role === 'core'; }).sort(function (a, b) { return a.pri - b.pri; });
    if (band !== 'u12') {                                                        // 2. u12: no add-ons
      var cap = rx ? 1 : 3, cats = {}, picks = [], rest = [];                     // 6. cap at three, one per category
      elig.filter(function (p) { return p.role === 'addon'; }).forEach(function (p) {
        var c = (p.cat || '').toLowerCase();
        if (picks.length < cap && !cats[c]) { cats[c] = 1; picks.push(p); } else rest.push(p);
      });
      while (picks.length < cap && rest.length) picks.push(rest.shift());
      r.addons = picks;
    }
    elig.filter(function (p) { return p.role === 'always'; }).forEach(function (p) {   // 7. always-shown
      if (/sunscreen|spf/i.test(p.cat || '')) r.spf.push(p); else r.always.push(p);
    });
    var fun = elig.filter(function (p) { return p.role === 'fun'; });            // 8. one fun pick, stable per answer set
    if (fun.length) { var h = 0, s = encodeAnswers(); for (var i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0; r.fun = fun[h % fun.length]; }
    var coreH = r.core.map(function (p) { return p.ph; });
    r.routine = band !== 'u12' && !rx && root.dataset.setAvailable === '1' && LF.every(function (x) { return coreH.indexOf(x) !== -1; });
    r.starter = band === 'u12';
    r.parentPrimary = r.audience === 'teen' || band === '13-18' || band === 'u12';
    return r;
  }

  /* ---- reasons: first matching block wins, else the slot's default ---- */
  function slotText(slot, tags, ph) {
    for (var i = 0; i < reasons.length; i++) {
      var r = reasons[i];
      if (r.slot !== slot || !r.text) continue;
      if (slot === 'line' && r.ph !== ph) continue;
      if (!r.tag || has(tags, r.tag)) return r.text;
    }
    return data.defaults[slot] || '';
  }
  function lineFor(p, tags) { return slotText('line', tags, p.ph) || p.line || ''; }

  /* ---- rendering ---- */
  function card(p, opts) {
    var tpl = root.querySelector('[data-lf-card]').content.cloneNode(true), el = tpl.firstElementChild;
    var media = el.querySelector('.lf-quiz__pick-media'), img = el.querySelector('img');
    media.href = p.u; if (p.img) { img.src = p.img; img.alt = p.n; } else media.hidden = true;
    var step = el.querySelector('.lf-quiz__step'); if (opts.step) step.textContent = opts.step; else step.remove();
    var name = el.querySelector('.lf-quiz__pick-name a'); name.href = p.u; name.textContent = p.n;
    el.querySelector('.lf-quiz__brand').textContent = p.b || '';
    var why = el.querySelector('.lf-quiz__why'), line = opts.line;
    if (line) { why.querySelector('strong').textContent = opts.prefix || ''; why.querySelector('span').textContent = line; } else why.remove();
    el.querySelector('.lf-quiz__price').textContent = p.pr;
    var btn = el.querySelector('[data-lf-add-item]');
    if (opts.buy === false) btn.remove(); else { btn.textContent = p.av ? L.add : L.soldout; btn.dataset.variant = p.id; btn.dataset.available = p.av ? '1' : '0'; if (!p.av) btn.disabled = true; }
    return el;
  }
  function fillGroup(name, list, opts) {
    var g = root.querySelector('[data-lf-group="' + name + '"]'); if (!g) return;
    var box = g.querySelector('[data-lf-list]'); box.innerHTML = '';
    g.hidden = !list.length; if (!list.length) return;                          // an empty category never renders an empty slot
    var k = g.querySelector('[data-lf-gkicker]'); if (k) k.textContent = opts.kicker || '';
    list.forEach(function (p, i) { box.appendChild(card(p, { step: opts.steps ? (L.step + ' ' + (i + 1) + (p.cat ? ' · ' + p.cat.toLowerCase() : '')) : '', line: opts.lines ? lineFor(p, opts.tags) : '', prefix: opts.prefix, buy: opts.buy })); });
  }
  function part(name, on) { root.querySelectorAll('[data-lf-part="' + name + '"]').forEach(function (el) { el.hidden = !on; }); }
  function chips(labels) {
    var c = root.querySelector('[data-lf-chips]'); if (!c) return; c.innerHTML = '';
    labels.forEach(function (l) { var s = document.createElement('span'); s.className = 'lf-quiz__chip'; s.textContent = l; c.appendChild(s); });
  }
  function rankFiles(tags) {
    var files = root.querySelector('[data-lf-files]'); if (!files) return;
    var all = Array.prototype.slice.call(files.children), tagOf = function (f) { return (f.dataset.tags || '').trim(); };
    var ranked = all.filter(function (f) { return tagOf(f) && has(tags, tagOf(f)); }).concat(all.filter(function (f) { return !tagOf(f); })).concat(all.filter(function (f) { return tagOf(f) && !has(tags, tagOf(f)); }));
    all.forEach(function (f) { f.hidden = true; });
    ranked.slice(0, 3).forEach(function (f) { f.hidden = false; });
  }
  function fillTips(tags) {
    var box = root.querySelector('[data-lf-tips]'); if (!box) return; box.innerHTML = '';
    var list = tips.filter(function (t) { return t.tag && has(tags, t.tag); }).concat(tips.filter(function (t) { return !t.tag; })).slice(0, 3);
    list.forEach(function (t) { var d = document.createElement('div'); d.className = 'lf-quiz__tip'; var h = document.createElement('h3'); h.className = 'lf-quiz__tip-t'; h.textContent = t.title || ''; var p = document.createElement('p'); p.className = 'lf-quiz__tip-p'; p.textContent = t.text || ''; d.appendChild(h); d.appendChild(p); box.appendChild(d); });
    part('tips', list.length > 0);
  }
  function renderResult(r) {
    var tags = r.tags;
    chips(r.labels);
    root.querySelectorAll('[data-lf-screen="result"] [data-lf-slot]').forEach(function (el) {
      var s = el.dataset.lfSlot;
      if (s === 'why_sub') return;
      if (s === 'rx_lead') { el.textContent = slotText('rx_lead', tags); return; }
      el.textContent = (r.exit === 'rx' && s === 'headline') ? (slotText('rx_headline', tags) || slotText('headline', tags)) : slotText(s, tags);
    });
    var rl = root.querySelector('[data-lf-rlabel]'); if (rl) rl.textContent = r.exit === 'refer' ? L.exitLabel : L.resultLabel;
    root.classList.toggle('is-exit', r.exit === 'refer');
    if (r.exit === 'refer') {                                                    // no products, no buy button, anywhere
      ['routine', 'routine-btn', 'rx', 'spf', 'tips', 'fun', 'share', 'wild', 'email'].forEach(function (p) { part(p, false); });
      ['headline', 'lead', 'second'].forEach(function (k) { var el = root.querySelector('[data-lf-screen="result"] [data-lf-slot="' + k + '"]'); if (el) el.textContent = ''; });
      part('refer', true); rankFiles(tags); return;
    }
    part('refer', false);
    part('rx', r.exit === 'rx');
    fillGroup('core', r.core, { kicker: L.coreKicker, steps: r.core.length > 1, lines: true, prefix: L.forYou, tags: tags, buy: true });
    fillGroup('addon', r.addons, { kicker: L.addonKicker, lines: true, prefix: L.forYou, tags: tags, buy: true });
    fillGroup('always', r.always, { kicker: L.alwaysKicker, lines: true, prefix: L.forYou, tags: tags, buy: true });
    part('routine', r.core.length + r.addons.length + r.always.length > 0);
    part('routine-btn', r.routine);
    var sb = root.querySelector('[data-lf-add-set]'); if (sb) { sb.textContent = L.routine; sb.classList.remove('is-done'); }
    if (r.starter && r.core[0]) { var b0 = root.querySelector('[data-lf-group="core"] [data-lf-add-item]'); if (b0) { b0.textContent = L.starter; b0.classList.add('lf-quiz__btn--poppy', 'lf-quiz__btn--shadow'); b0.classList.remove('lf-quiz__btn--plum', 'lf-quiz__btn--sm'); } }
    fillGroup('spf', r.spf, { lines: true, prefix: L.forYou, tags: tags, buy: true }); part('spf', true);
    fillTips(tags);
    fillGroup('fun', r.fun ? [r.fun] : [], { buy: true }); part('fun', !!r.fun);
    part('share', true); part('wild', true);
    root.classList.toggle('is-parent-primary', r.parentPrimary);
    part('email', r.band !== 'u12');                                             // never the child's email
    rankFiles(tags);
    refreshShare();
  }
  function shareLink(name) {
    var u = new URL(root.dataset.shareBase, window.location.origin);
    u.searchParams.set('share', encodeAnswers()); if (exitType) u.searchParams.set('exit', exitType);
    if (name) u.searchParams.set('from', name);
    return u.toString();
  }
  function resultUrl() { var u = new URL(window.location.href); ['q', 'a', 'share', 'from', 'preset'].forEach(function (k) { u.searchParams.delete(k); }); u.searchParams.set('r', encodeAnswers()); if (exitType) u.searchParams.set('exit', exitType); else u.searchParams.delete('exit'); return u.toString(); }
  function senderName() { var inp = root.querySelector('[data-lf-name]'); return inp ? inp.value.trim().slice(0, 40) : ''; }
  function refreshShare() {
    var name = senderName() || L.anon, link = shareLink(senderName());
    var prev = root.querySelector('[data-lf-preview]'); if (prev) prev.textContent = (L.shareMsg || '').replace('{name}', name);
    var sms = root.querySelector('[data-lf-sms]'); if (sms) { sms.hidden = false; sms.href = 'sms:?&body=' + encodeURIComponent((L.sms || '').replace('{link}', link)); }
  }
  root.addEventListener('input', function (e) { if (e.target.matches('[data-lf-name]')) refreshShare(); });
  function showResult(push) {
    result = route(); exitType = result.exit;
    renderResult(result);
    show('result');
    setUrl({ r: encodeAnswers(), exit: exitType }, push);
    /* Anonymous-capture hook (NOT built, not approved): a listener could count completions
       here. The detail carries no identifier and no private answer. */
    try { document.dispatchEvent(new CustomEvent('lf:quiz:complete', { detail: { band: result.band, audience: result.audience, skus: result.core.concat(result.addons).map(function (p) { return p.ph; }) } })); } catch (e) {}
  }
  function copyLink(btn) {
    var link = shareLink(senderName());
    var done = function () { btn.textContent = L.copied; btn.classList.add('is-done'); setTimeout(function () { btn.textContent = L.copy; btn.classList.remove('is-done'); }, 3500); };
    if (navigator.share && /Android|iPhone|iPad/i.test(navigator.userAgent)) navigator.share({ url: link, text: (L.sms || '').replace('{link}', '') }).then(done).catch(function () { clip(link).then(done); });
    else clip(link).then(done);
  }
  function clip(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(text).catch(function () { return fallbackCopy(text); });
    return Promise.resolve(fallbackCopy(text));
  }
  function fallbackCopy(text) { var ta = document.createElement('textarea'); ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0'; document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); } catch (e) {} document.body.removeChild(ta); }

  /* ---- parent view: the known adult ---- */
  function showParent(name, push) {
    result = route();                                                            // exitType (from the link) is honoured inside route()
    if (result.exit === 'refer') { renderResult(result); show('result'); setUrl({ r: encodeAnswers(), exit: 'refer' }, push); return; }
    var tags = result.tags;
    root.querySelectorAll('[data-lf-screen="parent"] [data-lf-slot]').forEach(function (el) { el.textContent = slotText(el.dataset.lfSlot, tags); });
    var line = root.querySelector('[data-lf-sender-line]'); if (line) line.textContent = (L.sender || '').replace('{name}', name || L.anon);
    var all = result.core.concat(result.addons);
    fillGroup('pcore', result.core, { steps: result.core.length > 1, lines: true, prefix: L.forThem, tags: tags, buy: !result.routine });
    fillGroup('paddon', result.addons, { kicker: L.addonKicker, lines: true, prefix: L.forThem, tags: tags, buy: true });
    if (result.starter) { var pb0 = root.querySelector('[data-lf-group="pcore"] [data-lf-add-item]'); if (pb0) { pb0.textContent = L.starter; pb0.classList.add('lf-quiz__btn--poppy'); pb0.classList.remove('lf-quiz__btn--plum', 'lf-quiz__btn--sm'); } }
    var seen = {}, withIng = all.filter(function (p) { return p.ing; });
    withIng.forEach(function (p) { String(p.ing).split(/,\s*/).forEach(function (x) { x = x.trim().toLowerCase(); if (x) seen[x] = 1; }); });
    var cnt = root.querySelector('[data-lf-count-line]'); if (cnt) cnt.textContent = (L.count || '').replace('{steps}', String(all.length)).replace('{n}', String(Object.keys(seen).length));
    var cta = root.querySelector('[data-lf-parent-cta]'), foot = root.querySelector('[data-lf-parent-foot]');
    cta.innerHTML = ''; foot.querySelectorAll('[data-lf-add-set]').forEach(function (b) { b.remove(); });
    if (result.routine) {
      var mk = function () { var b = document.createElement('button'); b.type = 'button'; b.className = 'lf-quiz__btn lf-quiz__btn--poppy lf-quiz__btn--shadow'; b.setAttribute('data-lf-add-set', ''); b.textContent = L.routine + ' · ' + root.dataset.setPrice; return b; };
      cta.appendChild(mk()); foot.insertBefore(mk(), foot.firstChild);
    }
    var inc = root.querySelector('[data-lf-incis]'); inc.innerHTML = '';
    withIng.forEach(function (p, i) { var t = root.querySelector('[data-lf-inci]').content.cloneNode(true), d = t.firstElementChild; d.querySelector('summary span').textContent = p.n; d.querySelector('.lf-quiz__inci-list').textContent = p.ing; if (i === 0) d.open = true; inc.appendChild(d); });
    part('inci', withIng.length > 0);
    part('pemail', true);                                                        // the grown-up may want a copy; never the child
    try { sessionStorage.setItem('lf_known_adult', '1'); document.cookie = 'lf_known_adult=1; path=/; max-age=86400; SameSite=Lax'; } catch (e) {}
    show('parent');
    setUrl({ share: encodeAnswers(), exit: exitType, from: name || '' }, push);
  }

  /* ---- add to bag: one variant, then let the drawer know ---- */
  function addItem(btn, id, available) {
    if (!id || !available) { btn.textContent = L.soldout; btn.disabled = true; return; }
    if (btn.classList.contains('is-busy') || btn.classList.contains('is-done')) return;
    btn.classList.add('is-busy');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        btn.classList.remove('is-busy'); btn.classList.add('is-done'); btn.textContent = L.added;
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('.cart-count, [data-cart-count], .lf-head__cart-count, cart-count').forEach(function (el) { el.textContent = cart.item_count; el.classList.add('is-visible'); });
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cart } }));
          var drawer = document.getElementById('cart-drawer'); if (drawer && typeof drawer.show === 'function') drawer.show();
        }).catch(function () {});
      })
      .catch(function () { btn.classList.remove('is-busy'); window.location.assign('/cart/add?id=' + id + '&quantity=1'); });
  }

  /* ---- email me my results: a Klaviyo event with profile properties. Never rx, never refer. ---- */
  root.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-lf-email-form]'); if (!f) return;
    e.preventDefault();
    var inp = f.querySelector('[data-lf-email]'), msg = f.querySelector('[data-lf-email-msg]'), email = inp.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { inp.focus(); return; }
    /* Sending the results is an email capture, so it carries the same 13-or-older box as
       every other one, required and never pre-ticked. It is not a wall: the download button
       beside it gives the same results with no email and no age question at all. */
    var age = f.querySelector('[data-lf-quiz-age]');
    if (age && !age.checked) { msg.textContent = L.ageErr || ''; age.focus(); return; }
    var r = result || route(), t = r.tags, keyed = tagsFor().keyed;
    var props = {
      quiz_audience: r.audience, quiz_band: r.band, quiz_type: keyed.type || '',
      quiz_concern: t.filter(function (x) { return x.indexOf(':') === -1 && ['oily', 'dry', 'combo', 'normal', 'swim', 'sports', 'outdoors', 'fragranced-laundry'].indexOf(x) === -1; }).join(', '),
      quiz_lane: t.filter(function (x) { return ['swim', 'sports', 'outdoors'].indexOf(x) !== -1; }).join(', '),
      quiz_routine: r.core.concat(r.addons).map(function (p) { return p.ph; }).join(', '),
      quiz_date: new Date().toISOString().slice(0, 10), quiz_result_url: resultUrl()
    };
    var body = { data: { type: 'event', attributes: { metric: { data: { type: 'metric', attributes: { name: root.dataset.klaviyoMetric || 'Requested Quiz Results' } } }, properties: props, profile: { data: { type: 'profile', attributes: { email: email, properties: props } } } } } };
    f.classList.add('is-busy');
    /* the list, so a quiz taker is reachable, and the event, so the result is readable */
    if (root.dataset.klaviyoList) {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(root.dataset.klaviyo), {
        method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'skin-quiz', profile: { data: { type: 'profile', attributes: { email: email, properties: props } } } }, relationships: { list: { data: { type: 'list', id: root.dataset.klaviyoList } } } } })
      }).catch(function () {});
    }
    fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(root.dataset.klaviyo), { method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' }, body: JSON.stringify(body) })
      .then(function (res) { if (!res.ok && res.status !== 202) throw new Error('klaviyo'); f.classList.remove('is-busy'); f.classList.add('is-done'); msg.textContent = L.emailOk; inp.disabled = true; })
      .catch(function () { f.classList.remove('is-busy'); msg.textContent = L.emailErr; });
  });

  /* ---- download the results, the ungated way out ----------------------------------
     Dana's ruling (2026-09-23): the results can be emailed behind the 13-or-older box, OR
     downloaded straight off the screen. So this asks for nothing, sends nothing, and calls
     nobody: it draws what is already on the page onto a canvas and hands over the PNG.
     A phone saves it to the camera roll, which is where a teenager actually keeps things. */
  function wrapLines(ctx, text, max) {
    var words = String(text || '').split(/\s+/), lines = [], line = '';
    for (var i = 0; i < words.length; i++) {
      var next = line ? line + ' ' + words[i] : words[i];
      if (ctx.measureText(next).width > max && line) { lines.push(line); line = words[i]; } else line = next;
    }
    if (line) lines.push(line);
    return lines;
  }
  function resultRows() {
    var r = result || route(), rows = [];
    (r.core || []).forEach(function (p, i) { rows.push({ step: (L.step || 'step') + ' ' + (i + 1), name: p.n, brand: p.b || '' }); });
    (r.addons || []).forEach(function (p) { rows.push({ step: L.addonKicker || '', name: p.n, brand: p.b || '' }); });
    return rows;
  }
  function loadImg(src) {
    return new Promise(function (res) {
      if (!src) return res(null);
      var im = new Image();
      im.crossOrigin = 'anonymous';               /* or toBlob throws on a tainted canvas */
      im.onload = function () { res(im); };
      im.onerror = function () { res(null); };
      im.src = src.indexOf('?') === -1 ? src + '?width=240' : src + '&width=240';
    });
  }
  function roundRect(x, X, Y, W, H, R) { x.beginPath(); x.moveTo(X + R, Y); x.arcTo(X + W, Y, X + W, Y + H, R); x.arcTo(X + W, Y + H, X, Y + H, R); x.arcTo(X, Y + H, X, Y, R); x.arcTo(X, Y, X + W, Y, R); x.closePath(); }
  function drawResults() {
    var W = 1080, PAD = 72, MAXW = W - PAD * 2, TH = 128, GAP = 28;
    var r = result || route();
    var picks = (r.core || []).map(function (p, i) { return { p: p, step: (L.step || 'step') + ' ' + (i + 1) }; })
      .concat((r.addons || []).map(function (p) { return { p: p, step: '' }; }));
    var tips = Array.prototype.slice.call(root.querySelectorAll('.lf-quiz__tip-t')).map(function (t) { return t.textContent.trim(); }).slice(0, 3);
    var said = Array.prototype.slice.call(root.querySelectorAll('[data-lf-chips] .lf-quiz__chip')).map(function (t) { return t.textContent.trim(); });
    var link = resultUrl();
    var nCore = (r.core || []).length;
    return Promise.all(picks.map(function (it) { return loadImg(it.p.img); })).then(function (imgs) {
      var c = document.createElement('canvas'), x = c.getContext('2d');
      /* One layout walk run twice, once to size and once to draw. Any second height formula
         drifts the moment a routine has four steps instead of three. */
      function walk(draw) {
        var y = PAD + 30;
        function kicker(t) {
          if (draw) { x.fillStyle = '#F15641'; x.font = '700 24px "Instrument Sans", system-ui, sans-serif'; x.letterSpacing = '3px'; x.fillText(String(t).toUpperCase(), PAD, y); x.letterSpacing = '0px'; }
          y += 46;
        }
        kicker(L.resultLabel || 'your routine');
        x.font = '600 54px "Instrument Sans", system-ui, sans-serif';
        wrapLines(x, L.forYou || 'built for you', MAXW).forEach(function (ln) { if (draw) { x.fillStyle = '#E8E9C9'; x.fillText(ln, PAD, y); } y += 62; });
        /* what she told us, so the card still makes sense to a parent weeks later */
        if (said.length) {
          y += 14;
          x.font = '400 27px "Instrument Sans", system-ui, sans-serif';
          wrapLines(x, said.join('  ·  '), MAXW).forEach(function (ln) { if (draw) { x.fillStyle = 'rgba(232,233,201,.72)'; x.fillText(ln, PAD, y); } y += 38; });
        }
        y += 34;
        picks.forEach(function (it, i) {
          if (i === nCore && nCore) { y += 10; kicker(L.addonKicker || 'if you want more'); }
          var top = y, tx = PAD, im = imgs[i];
          if (im) { tx = PAD + TH + GAP; if (draw) { x.save(); roundRect(x, PAD, top - 8, TH, TH, 22); x.clip(); x.fillStyle = '#FFFFFF'; x.fillRect(PAD, top - 8, TH, TH); x.drawImage(im, PAD, top - 8, TH, TH); x.restore(); } }
          var w2 = W - tx - PAD, ty = top + 22;
          if (it.step) { if (draw) { x.fillStyle = '#F15641'; x.font = '700 21px "Instrument Sans", system-ui, sans-serif'; x.letterSpacing = '2px'; x.fillText(it.step.toUpperCase(), tx, ty); x.letterSpacing = '0px'; } ty += 36; }
          x.font = '600 34px "Instrument Sans", system-ui, sans-serif';
          wrapLines(x, it.p.n, w2).forEach(function (ln) { if (draw) { x.fillStyle = '#FFFFFF'; x.fillText(ln, tx, ty); } ty += 44; });
          if (it.p.b) { if (draw) { x.fillStyle = 'rgba(255,255,255,.6)'; x.font = '400 25px "Instrument Sans", system-ui, sans-serif'; x.fillText(it.p.b, tx, ty); } ty += 32; }
          y = Math.max(ty, top + (im ? TH + 18 : 0)) + 22;
        });
        if (tips.length) {
          y += 12; kicker('remember');
          x.font = '400 29px "Instrument Sans", system-ui, sans-serif';
          tips.forEach(function (t) {
            wrapLines(x, '· ' + t, MAXW).forEach(function (ln) { if (draw) { x.fillStyle = 'rgba(232,233,201,.92)'; x.fillText(ln, PAD, y); } y += 39; });
            y += 14;
          });
        }
        /* the link, so the picture is not a dead end: it opens the real thing, with every
           product still clickable and still in stock or not */
        y += 26;
        if (draw) { x.strokeStyle = 'rgba(255,255,255,.18)'; x.lineWidth = 2; x.beginPath(); x.moveTo(PAD, y - 26); x.lineTo(W - PAD, y - 26); x.stroke(); }
        kicker(L.dlLinkKicker || 'open your routine');
        x.font = '400 24px "Instrument Sans", system-ui, sans-serif';
        wrapLines(x, link, MAXW).forEach(function (ln) { if (draw) { x.fillStyle = 'rgba(255,255,255,.72)'; x.fillText(ln, PAD, y); } y += 34; });
        return y + PAD - 20;
      }
      c.width = W; c.height = 100;                 /* measureText needs a live context */
      var h = walk(false);
      c.width = W; c.height = Math.round(h);       /* resizing resets the context, so restyle */
      x.fillStyle = '#4A2E45'; x.fillRect(0, 0, W, h);
      walk(true);
      return c;
    });
  }
  function resultsBlob() {
    return drawResults().then(function (canvas) {
      return new Promise(function (res, rej) {
        try { canvas.toBlob(function (b) { b ? res(b) : rej(new Error('blob')); }, 'image/png'); } catch (e) { rej(e); }
      });
    });
  }
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lf-dl-results], [data-lf-share-results]'); if (!btn) return;
    var share = btn.hasAttribute('data-lf-share-results');
    var msg = btn.closest('.lf-quiz__block').querySelector('[data-lf-dl-msg]');
    var go = function () {
      resultsBlob().then(function (blob) {
        var file = new File([blob], 'my-live-free-routine.png', { type: 'image/png' });
        /* share hands a friend or a parent the picture AND the working link in one go */
        if (share && navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
          return navigator.share({ files: [file], text: L.shareMsg ? L.shareMsg.replace('{name}', L.anon || '') : '', url: resultUrl() })
            .then(function () { if (msg) msg.textContent = ''; }, function () {});
        }
        if (share && navigator.clipboard) {
          return navigator.clipboard.writeText(resultUrl()).then(function () { if (msg) msg.textContent = L.copied || ''; }, function () {});
        }
        var url = URL.createObjectURL(blob), a = document.createElement('a');
        a.href = url; a.download = 'my-live-free-routine.png';
        document.body.appendChild(a); a.click(); a.remove();
        setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
        if (msg) msg.textContent = L.dlDone || '';
      }).catch(function () { if (msg) msg.textContent = L.emailErr || ''; });
    };
    /* the brand face has to be loaded or the canvas silently falls back to a system font */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(go, go); else go();
  });

  /* ---- route from the URL ---- */
  function preset(n) {
    var lines = String(root.dataset.presets || '').split('\n');
    for (var i = 0; i < lines.length; i++) { var m = lines[i].match(/^\s*(\d+)\s*=\s*([\d.+]+)/); if (m && m[1] === n) return m[2]; }
    return '';
  }
  function route0(push) {
    var p = new URL(window.location.href).searchParams;
    exitType = p.get('exit') === 'rx' || p.get('exit') === 'refer' ? p.get('exit') : '';
    if (p.get('preset')) { var pa = preset(p.get('preset')); if (pa) { answers = parseAnswers(pa); showResult(false); return; } }
    if (p.get('share') !== null) { answers = parseAnswers(p.get('share')); showParent(p.get('from') || '', push); return; }
    if (p.get('r') !== null) { answers = parseAnswers(p.get('r')); var vi = visibleIdx(); if (answers.length >= vi[vi.length - 1] + 1) { result = route(); renderResult(result); show('result'); return; } }
    answers = parseAnswers(p.get('a'));
    var q = (parseInt(p.get('q'), 10) || 1) - 1;
    if (q > answers.length) q = answers.length;
    showQuestion(q, push);
  }
  window.addEventListener('popstate', function () { route0(false); });
  route0(false);
})();